import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'

interface GlobalSearchState {
  isShowing: boolean
  searchTerm: string
}

const INITIAL_STATE: GlobalSearchState = {
  isShowing: false,
  searchTerm: '',
}

const globalSearchSlice = createSlice({
  name: 'globalSearch',
  initialState: INITIAL_STATE,
  reducers: {
    setIsShowing: (
      state,
      action: PayloadAction<GlobalSearchState['isShowing']>,
    ) => {
      state.isShowing = action.payload
    },
    setSearchTerm: (
      state,
      action: PayloadAction<GlobalSearchState['searchTerm']>,
    ) => {
      state.searchTerm = action.payload
    },
  },
})

export const selectGlobalSearch = (state: RootState) => state.globalSearch

export const selectIsShowing = createSelector(
  selectGlobalSearch,
  (state) => state.isShowing,
)

export const selectSearchTerm = createSelector(
  selectGlobalSearch,
  (state) => state.searchTerm,
)

export const { setIsShowing, setSearchTerm } = globalSearchSlice.actions

export const globalSearchReducer = globalSearchSlice.reducer
